import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveFormRecord from "../../../Components/CluppForms/saveFormRecord";
import CancelationReason from "./CancelationReason";
import Swal from "sweetalert2";
import { getProductData } from "../../../utils/getUserUtility";

const landingId = "CF_SELECT_REASON_TO_CANCEL";

const onLoad = async ({ session, landedAt, uid, fieldsStructure }) => {
  const prevAnswers = {};
  const cancelationReasons = [];
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;

  const prevItemLanding = prevForm.items.find(
    (items) => items.landingId === "CF_SELECT_PRODUCT_TO_CANCEL" // Prev Landing
  );
  if (prevItemLanding) {
    const lastField = prevItemLanding?.answers[0];
    const fieldID = lastField.field.id;
    const lastFieldType = lastField.type;
    const lastFieldAnswers = lastField[lastFieldType]?.value;
    prevAnswers[fieldID] = lastFieldAnswers;
  }

  const itemsFromThisLanding = prevForm.items.find(
    (items) => items.landingId === landingId
  );
  if (itemsFromThisLanding) {
    const thisField = itemsFromThisLanding?.answers[0];
    const thisFieldType = thisField.type; // choice
    const thisFieldAnswers = thisField[thisFieldType].value;
    cancelationReasons.push(thisFieldAnswers);
  }

  const productsToCancel = landings[0];
  const productsField = productsToCancel.answers[0];
  const productType = productsField.type;
  const products = productsField[productType].value;

  const devices = ["smartphone", "laptop", "tablet"];
  const isADeviceCheck = (d) => devices.includes(d) || d === "devices";

  const isMultipleProducts = products.length > 1;
  const isADevice =
    !isMultipleProducts &&
    products.length > 0 &&
    isADeviceCheck(products[0].type);

  let productData = {};

  if (!isMultipleProducts) {
    const product = products[0];
    productData = await getProductData(uid, {
      id: product.id,
      type: product.type,
    });
  }

  return {
    userId: uid,
    ...prevAnswers,
    [fieldsStructure[0].field.id]: cancelationReasons,
    landedAt,
    prevForm,
    currentLanding: landingId,
    isMultipleProducts,
    isADevice,
    products,
    productData,
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
  setLoading,
}) => {
  if (session?.sessionID) {
    try {
      const path = `IT/forms/cancelation-form/${session.sessionID}`;
      const docRef = doc(db, path);
      const prevForm = await getFormSession(
        "cancelation-form",
        session.sessionID
      );
      const lastField = prevForm.items[1];
      const newLanding = {
        landingId,
        landedAt: state.landedAt,
        submittedAt: Date.now(),
      };
      const fieldID = fieldsStructure[0].field.id;
      const optionSelected = state[fieldID][0];
      let value = optionSelected;
      if (!optionSelected?.id) {
        setLoading(false);
        return Swal.fire({
          icon: "warning",
          text: "Por favor, selecciona una de las opciones.",
          confirmButtonColor: "#00bbee",
        });
      }
      if (optionSelected.id === "Otro") {
        value = optionSelected;
      }
      const field = fieldsStructure[0];
      const fieldType = field.type;

      field[fieldType].value = value;
      const answers = [field];
      newLanding.answers = answers;
      const updateData = lastField
        ? [prevForm.items[0], newLanding]
        : arrayUnion(newLanding);

      await saveFormRecord(session.sessionID, {
        ...prevForm,
        pageCount: 2,
        items: updateData,
      });
      await updateDoc(docRef, {
        pageCount: 2,
        items: updateData,
        processed: false,
      });

      console.log("State successfully written to Firestore!");
      if (nextPage) navigate(nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <CancelationReason
    state={state}
    setState={setState}
    field={"CF_choose_reason_jq8t7"}
  /> // Field ID
);

const nextPage = (props) => {
  const answers = props["CF_choose_reason_jq8t7"][0];
  const isMultipleProducts = props.isMultipleProducts;
  const { period, insurancePauseCount } = props?.productData;
  if (answers.id === "Encontré un mejor seguro")
    return `/formulario/cancelacion/valuacion?uid=${props.uid}`;

  if (answers.id === "No me gusta el seguro de Clupp")
    return `/formulario/cancelacion/no-gusto?uid=${props.uid}`;

  if (answers.id === "Solo lo necesitaba para un trámite")
    return `/formulario/cancelacion/tramite?uid=${props.uid}`;

  if (answers.id === "Dificultad económica") {
    if (period !== "month" && !isMultipleProducts) {
      return `/formulario/cancelacion/cambiar-periodicidad?uid=${props.uid}`;
    }
    return `/formulario/cancelacion/lealtad?uid=${props.uid}`;
  }

  if (
    answers.id ===
    `Vendí o cambié mi ${props.isADevice ? "dispositivo" : "vehículo"}`
  )
    return `/formulario/cancelacion/upsell?uid=${props.uid}`;

  if (
    answers.id ===
    `Casi no uso mi ${props.isADevice ? "dispositivo" : "vehículo"}`
  ) {
    if (insurancePauseCount >= 1) {
      return `/formulario/cancelacion/lealtad?uid=${props.uid}`;
    }

    if (period === "month") {
      return `/formulario/cancelacion/pausar?uid=${props.uid}`;
    }
  }

  return `/formulario/cancelacion/lealtad?uid=${props.uid}`;
};
const prevPage = (props) => `/formulario/cancelacion/producto?uid=${props.uid}`;
const fieldsStructure = [
  {
    field: {
      id: "CF_choose_reason_jq8t7",
      type: "multiple_choice",
      ref: "CF_choose_reason",
    },
    metadata: {},
    type: "choice",
    choice: {
      value: "",
    },
  },
];

const selectReasonProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default selectReasonProps;
